const btnSearchOpen = document.querySelector('#searchBtn');
const searchDiv = document.querySelector('#search');
const btnMenuClose = document.querySelector('#searchBtnClose');

export default class Search {
  static toggle = function () {
    btnSearchOpen.addEventListener('click', function () {
      //toggle modal
      searchDiv.classList.contains('open')
        ? searchDiv.classList.remove('open')
        : searchDiv.classList.add('open');
    });
    btnMenuClose.addEventListener('click', function () {
      searchDiv.classList.remove('open');
      console.log('click close');
    });
  };

  static init() {
    Search.toggle();
    console.log('init');
    //MenuToggle.toggleSubmenu();
  }
}
